<template>
  <div class="question mt-3">
    <div class="card">
      <div class="card-header">
        <span class="badge badge-primary mr-2">{{ currentQuestionNumber }} / {{ numberOfQuestions }}</span>{{ question.question }}
      </div>
      <div class="card-body">
        <div v-for="(answer, index) in question.answers" :key="index">
          <b-button
            class="mt-1"
            block
            @click="clickAnswer(answer)"
          >{{ answer }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {

  name: 'QuestionComponent',

  props: {
    question: Object,
    currentQuestionNumber: Number, 
    numberOfQuestions: Number
  },

  methods: {
    clickAnswer: function(answer) {
      const urlParams = new URLSearchParams(window.location.search);
      const deviceId = urlParams.get('deviceId') || 'undefined'

      return axios
          .post("https://europe-west1-selectivv-dt-production.cloudfunctions.net/insertSurveyAnswerToBq", {
            deviceId: deviceId,
            question: this.question.question,
            answer: answer
          })
          .then(() => {
            this.$emit('question-answered')
          });
    }
  }
}
</script>

<style scoped>
.btn {
  background-color: #168e66;
}

.btn:hover {
  background-color: #0F5E44;
}

.badge.badge-primary {
  background-color: #168e66;
  border-radius: 30px;
  position: relative;
  bottom: 3px;
}

h1 { font-size: 1.5rem; }
h2 { font-size: 1.3rem; }
h3 { font-size: 1.1rem; }
</style>
